import { render } from "./HelloWorld.vue?vue&type=template&id=a1a98dc2&scoped=true&bindings={}"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=a1a98dc2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a1a98dc2"

export default script